import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_panel/zadania/tematyczne/$uid')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/zadania/projekty/$uid', params })
  },
})
